export class UserSession {
    userId: number;
    userFullName: string;
    roleId: number;
    authToken: string;
    roleName: string;
    email: string;
    mobileNumber: string;
    languageType: number;
    clientId: any = [];
    currentClientId: any;
    currentClientName: any;
    isDynamicPassword: boolean;
    role: any = [];
    subDivisionId: number;
    blockId: number;
    regionId:number;
    divisionId:number;
    filterdivisionId:number;
    filterregionId:number
    filtersubdivisionId: number;
    filterblockId: number;
    districtId:number;
    userDistrictId:number;
    userBlockId:number;
    userVillageId:number;
    userGramPanjayatId:number;
    departmentId:number;
    userDistrictName:string;
    userBlockName:string;
    resultdata: string
}
